
import { KpmgMob, KpmgWeb, Lugbee, LugbeeHost, mobile, mobile2, Moviesflix, Ntts, Pmt, PortfolioWeb, projectThree, projectTwo, PvTool } from "../../assets/index";

export const ProjectList = [
    {
        id: 1,
        title: "KPMG EAM Website",
        des: "",
        src: KpmgWeb,
        link: "https://eamweb.tecorelabs.com/PYUAPSAM/homepage",
        repo: undefined,
        skills: ["React", "Axios", "Redux thunk"],
    },
    {
        id: 2,
        title: "KPMG EAM App",
        des: "",
        src: KpmgMob,
        link: undefined,
        repo: undefined,
        skills: ["React Native", , "Axios", "Redux thunk"],
    },
    {
        id: 3,
        title: "PVTool App",
        des: "Physical Verification Tool",
        src: PvTool,
        link: undefined,
        repo: undefined,
        skills: ["React", "Axios", "Redux thunk"],
    },
    {
        id: 4,
        title: "LugBee App",
        des: "",
        src: Lugbee,
        link: "https://play.google.com/store/apps/details?id=com.lugbee",
        repo: undefined,
        skills: ["React Native", "Axios", "Firebase", "Redux thunk", "Google Places"],
    },
    {
        id: 5,
        title: "LugBee Host App",
        des: "",
        src: LugbeeHost,
        link: undefined,
        repo: undefined,
        skills: ["React Native", "Axios", "Firebase", "Redux thunk", "Google Places"],
    },
    {
        id: 6,
        title: "Nimap Resourcing",
        des: "",
        src: undefined,
        link: "https://resourcing.nimapinfotech.com/",
        repo: undefined,
        skills: ["React", "Axios", "Ag Grid", "Redux", "React Select", "MUi"],
    },
    {
        id: 7,
        title: "TopperLearning",
        des: "",
        src: undefined,
        link: undefined,
        repo: undefined,
        skills: ["HTML", "CSS", "JavaScript", "JQuery", "SEO"],
    },
    {
        id: 8,
        title: "Gimme Gift",
        des: "",
        src: undefined,
        link: undefined,
        repo: undefined,
        skills: ["Expo", "Axios", "SupaBase", "Redux"],
    },
    {
        id: 9,
        title: "NTTS",
        des: "",
        src: Ntts,
        link: "https://ntts.nimapinfotech.com/",
        repo: undefined,
        skills: ["React", "Axios", "Redux"],
    },
    {
        id: 10,
        title: "PMT",
        des: "PMT is jira clone",
        src: Pmt,
        link: "https://pmt.nimapinfotech.com/",
        repo: undefined,
        skills: ["React", "Axios", "Redux"],
    },
    {
        id: 11,
        title: "AI Interior Design",
        des: "",
        src: undefined,
        link: undefined,
        repo: undefined,
        skills: ["Next.js", "Drizzle ORM", "RepliteAI Marketplace"],
    },
    {
        id: 12,
        title: "Meditation App ",
        des: "",
        src: undefined,
        link: undefined,
        repo: undefined,
        skills: ["React Native", "Supabase"],
    },
    {
        id: 13,
        title: "AI Resume Builder",
        des: "",
        src: undefined,
        link: undefined,
        repo: undefined,
        skills: ["React", "Supabase"],
    },

    {
        id: 14,
        title: "MahaBuzz News",
        des: "",
        src: undefined,
        link: undefined,
        repo: undefined,
        skills: ["React Native", "FireBase"],
    },

    {
        id: 15,
        title: "MoviesFlix Website",
        des: "Movies Info React App is a sleek and user-friendly application for accessing comprehensive movie information. It offers effortless search functionality, detailed movie summaries, cast details, release dates, and ratings. With its intuitive interface",
        src: Moviesflix,
        link: "https://moviesflix.techbeas.co.in",
        repo: "https://gitlab.com/roshanpatil2000/techbeas",
        skills: ["HTML", "CSS", "Javascript", "NodeJS", "React"],
    },

    {
        id: 16,
        title: "Personal Portfolio App",
        des: "The  Portfolio App is an impressive showcase of my skills, projects, and accomplishments. Through an aesthetically pleasing design and intuitive navigation, this platform provides visitors with a comprehensive overview of my expertise and capabilities.",
        src: PortfolioWeb,
        link: "https://techbeas.co.in",
        repo: "https://gitlab.com/roshanpatil2000/portfolio",
        skills: ["NodeJS", "React Native"],
    },
];
